import React from 'react'
import { TestSessionDetailWithResult_testSession, TestType } from '@modmd/data'
import { Box, BoxProps } from 'components/Layout'
import Button from 'components/Button'
import Icon from 'components/Icon'
import Card from 'components/Card'
import { Dialog } from 'components/Dialog'
import TextInput from 'components/TextInput'
import { Text } from 'components/Typography'
import { fontSizes, pxToRem } from 'theme'

interface Props extends Omit<BoxProps, 'onChange'> {
  initialSessionName: string | null
  onChange: (sessionChanges: Partial<TestSessionDetailWithResult_testSession>) => void
  isEditMode: boolean
  isEditLoading?: boolean
  titleFontSize?: string
  sessionType: TestType
}

export const SessionName: React.VFC<Props> = ({
  initialSessionName,
  isEditMode,
  isEditLoading,
  onChange,
  sessionType,
  titleFontSize = fontSizes.m,
  ...rest
}) => {
  const [sessionName, setSessionName] = React.useState<string | null>(null)
  const [isDialogOpen, setIsDialogOpen] = React.useState(false)
  const handleCloseDialog = () => setIsDialogOpen(false)

  React.useEffect(() => {
    setSessionName(initialSessionName)
  }, [initialSessionName])

  return (
    <Box {...rest}>
      <Button
        disabled={isEditLoading || !isEditMode}
        appearance="link"
        onClick={() => {
          setIsDialogOpen(true)
        }}
      >
        <Icon.Edit />
      </Button>
      <Text fontSize={titleFontSize} ml="0.5rem">
        Testing Session: {sessionName || 'No name'}{' '}
        {sessionType === TestType.RapidCovid19 ? 'Rapid ' : ''}
        {sessionType === TestType.Antigen ? 'Antigen ' : ''}
      </Text>
      <Dialog isOpen={isDialogOpen} onDismiss={handleCloseDialog} maxWidth={pxToRem(400)}>
        <Card.Title onDismiss={handleCloseDialog}>Edit Session Name</Card.Title>
        <Card.Content>
          <TextInput
            value={sessionName || ''}
            onChange={(e) => {
              setSessionName(e.target.value)
            }}
            isFullWidth
          />
          <Button
            width="100%"
            mt="2rem"
            isFetching={isEditLoading}
            onClick={() => {
              onChange({ name: sessionName })
            }}
          >
            Change
          </Button>
        </Card.Content>
      </Dialog>
    </Box>
  )
}
